import { render, staticRenderFns } from "./item-user.vue?vue&type=template&id=e1eb618a"
import script from "./item-user.vue?vue&type=script&lang=js"
export * from "./item-user.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports